
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[channelPath]/privacy",
      function () {
        return require("private-next-pages/[channelPath]/privacy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[channelPath]/privacy"])
      });
    }
  